// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__3bPYK","footer":"ChangeClinic_footer__12Lwi"};